import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useAccess } from "@/lib/access";

export const openOwner = () => window.dispatchEvent(new Event("owner-open"));

// Global owner PIN dialog: reachable from any screen; on success goes to the separate Owner Console.
export const OwnerPinDialog = () => {
  const access = useAccess();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  useEffect(() => {
    const h = () => (access.owner ? nav("/admin") : setOpen(true));
    window.addEventListener("owner-open", h);
    return () => window.removeEventListener("owner-open", h);
  }, [access.owner, nav]);
  const go = async (e) => {
    e.preventDefault();
    try { await access.login(pin); setPin(""); setOpen(false); toast.success("Owner console unlocked"); nav("/admin"); }
    catch (err) { toast.error(err.response?.data?.detail || "Wrong PIN"); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-[var(--card)] border-[var(--gold)]/40 text-slate-100 max-w-sm" data-testid="owner-pin-modal">
        <DialogHeader><DialogTitle className="flex items-center gap-2 font-head text-2xl uppercase"><ShieldCheck className="w-5 h-5 text-[var(--gold)]" />Owner console</DialogTitle>
          <DialogDescription className="text-slate-400">Enter your owner PIN to control bots, accounts and real-money trading.</DialogDescription></DialogHeader>
        <form onSubmit={go} className="space-y-3">
          <Input autoFocus type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="PIN" className="bg-[var(--bg)] border-[var(--line)] h-12 text-center text-xl tracking-[.5em] font-num" data-testid="owner-pin-input" />
          <button className="btn-primary w-full !bg-[var(--gold)]" data-testid="owner-pin-submit">Unlock</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
